import { useCallback, useEffect, useRef, useState } from "react";
import { useLanguage } from "@/lib/LanguageContext";

const PROJECT_META = [
    { href: "https://caminos.education/", live: true, type: "caminos", img: "/assets/images/caminos-hero.webp" },
    { href: "https://monarchhairstudio.netlify.app/", live: true, type: "monarch", img: "/assets/images/monarch-hero.webp" },
    { href: "https://jav-photo.netlify.app/", live: true, type: "jav", img: "/assets/images/jav-hero.webp" },
    { href: "https://414-visual-studio.netlify.app/", live: true, type: "visual414", img: "/assets/images/414-hero.webp" },
    { href: "https://fasttireservices.org/", live: true, type: "fasttire", img: "/assets/images/fasttire-hero.webp" },
    { href: "https://aleshka-doula.netlify.app/", live: true, type: "doula", img: "/assets/images/doula-hero.webp" },
    { href: "https://unicas-nail-estudio.netlify.app/", live: true, type: "unicas", img: "/assets/images/unicas-hero.webp" },
    { href: "#contact", live: false, type: "soon", img: null },
];

/* La imagen vive en su propia capa para poder hacerle zoom en hover
   sin arrastrar el texto superpuesto. */
function ShotBg({ image, position, shade }) {
    return (
        <div
            className="ps-shot-bg"
            aria-hidden="true"
            style={{
                backgroundImage: `linear-gradient(180deg, ${shade}), url(${image})`,
                backgroundSize: "cover",
                backgroundPosition: position,
            }}
        />
    );
}

function CaminosPreview({ t }) {
    return (
        <div className="ps-browser" data-testid="caminos-browser">
            <div className="ps-browser-bar">
                <i /><i /><i />
                <span className="ps-browser-url">caminos.education</span>
            </div>
            <div className="ps-browser-shot ps-shot-caminos">
                <ShotBg
                    image="/assets/images/caminos-hero.webp"
                    position="center 30%"
                    shade="rgba(10,18,12,0.15), rgba(8,14,10,0.75)"
                />
                <div className="ps-shot-nav">
                    <div className="ps-shot-brand">
                        <img
                            src="/assets/images/caminos-logo.webp"
                            alt=""
                            loading="lazy"
                            decoding="async"
                            onError={(e) => { e.target.style.display = "none"; }}
                        />
                        <b>Los Caminos</b>
                    </div>
                    <em>ES / EN</em>
                </div>
                <div className="ps-shot-hero">
                    <div className="ps-shot-kick">{t.projects.caminos.kick}</div>
                    <div className="ps-shot-h" dangerouslySetInnerHTML={{ __html: t.projects.caminos.heading }} />
                    <div className="ps-shot-cta">{t.projects.caminos.cta}</div>
                </div>
            </div>
        </div>
    );
}

function MonarchPreview({ t }) {
    return (
        <div className="ps-browser" data-testid="monarch-browser">
            <div className="ps-browser-bar">
                <i /><i /><i />
                <span className="ps-browser-url">monarchhairstudio.netlify.app</span>
            </div>
            <div className="ps-browser-shot ps-shot-monarch">
                <ShotBg
                    image="/assets/images/monarch-hero.webp"
                    position="center 8%"
                    shade="rgba(10,9,8,0.15), rgba(10,9,8,0.55)"
                />
                <div className="ps-shot-nav">
                    <div className="ps-shot-brand" style={{ fontFamily: "serif" }}>
                        <b>Monarch</b>
                    </div>
                    <em>{t.projects.monarch.cta}</em>
                </div>
                <div className="ps-shot-hero">
                    <div className="ps-shot-kick">{t.projects.monarch.kick}</div>
                    <div className="ps-shot-h" dangerouslySetInnerHTML={{ __html: t.projects.monarch.heading }} />
                    <div className="ps-shot-cta">{t.projects.monarch.cta}</div>
                </div>
            </div>
        </div>
    );
}

function JavPreview({ t }) {
    return (
        <div className="ps-browser" data-testid="jav-browser">
            <div className="ps-browser-bar">
                <i /><i /><i />
                <span className="ps-browser-url">jav-photo.netlify.app</span>
            </div>
            <div className="ps-browser-shot ps-shot-jav">
                <ShotBg
                    image="/assets/images/jav-hero.webp"
                    position="center 45%"
                    shade="rgba(28,20,16,0.34), rgba(28,20,16,0.22) 38%, rgba(28,20,16,0.74)"
                />
                <div className="ps-shot-nav">
                    <div className="ps-shot-brand" style={{ fontFamily: "serif", letterSpacing: "0.08em" }}>
                        <b>Javier Aldama</b>
                    </div>
                    <em>ES / EN</em>
                </div>
                <div className="ps-shot-hero">
                    <div className="ps-shot-kick">{t.projects.jav.kick}</div>
                    <div className="ps-shot-h" dangerouslySetInnerHTML={{ __html: t.projects.jav.heading }} />
                    <div className="ps-shot-cta">{t.projects.jav.cta}</div>
                </div>
            </div>
        </div>
    );
}

function Visual414Preview({ t }) {
    return (
        <div className="ps-browser" data-testid="visual414-browser">
            <div className="ps-browser-bar">
                <i /><i /><i />
                <span className="ps-browser-url">414-visual-studio.netlify.app</span>
            </div>
            <div className="ps-browser-shot ps-shot-414">
                <ShotBg
                    image="/assets/images/414-hero.webp"
                    position="center 50%"
                    shade="rgba(12,12,14,0.15), rgba(12,12,14,0.70)"
                />
                <div className="ps-shot-nav">
                    <div className="ps-shot-brand">
                        <b>414</b>
                    </div>
                    <em>{t.projects.visual414.cta}</em>
                </div>
                <div className="ps-shot-hero">
                    <div className="ps-shot-kick">{t.projects.visual414.kick}</div>
                    <div className="ps-shot-h" dangerouslySetInnerHTML={{ __html: t.projects.visual414.heading }} />
                    <div className="ps-shot-cta">{t.projects.visual414.cta}</div>
                </div>
            </div>
        </div>
    );
}

function FastTirePreview({ t }) {
    return (
        <div className="ps-browser" data-testid="fasttire-browser">
            <div className="ps-browser-bar">
                <i /><i /><i />
                <span className="ps-browser-url">fasttireservices.org</span>
            </div>
            <div className="ps-browser-shot ps-shot-fasttire">
                <ShotBg
                    image="/assets/images/fasttire-hero.webp"
                    position="center 55%"
                    shade="rgba(7,10,8,0.30), rgba(7,10,8,0.78)"
                />
                <div className="ps-shot-nav">
                    <div className="ps-shot-brand" style={{ textTransform: "uppercase", letterSpacing: "0.06em" }}>
                        <b>Fast Tire</b>
                    </div>
                    <em>ES / EN</em>
                </div>
                <div className="ps-shot-hero">
                    <div className="ps-shot-kick">{t.projects.fasttire.kick}</div>
                    <div className="ps-shot-h" dangerouslySetInnerHTML={{ __html: t.projects.fasttire.heading }} />
                    <div className="ps-shot-cta">{t.projects.fasttire.cta}</div>
                </div>
            </div>
        </div>
    );
}

function DoulaPreview({ t }) {
    return (
        <div className="ps-browser" data-testid="doula-browser">
            <div className="ps-browser-bar">
                <i /><i /><i />
                <span className="ps-browser-url">aleshka-doula.netlify.app</span>
            </div>
            <div className="ps-browser-shot ps-shot-doula">
                <ShotBg
                    image="/assets/images/doula-hero.webp"
                    position="center 40%"
                    shade="rgba(30,18,16,0.28), rgba(24,14,13,0.72)"
                />
                <div className="ps-shot-nav">
                    <div className="ps-shot-brand" style={{ fontFamily: "serif" }}>
                        <b>Aleshka Rodriguez</b>
                    </div>
                    <em>ES / EN</em>
                </div>
                <div className="ps-shot-hero">
                    <div className="ps-shot-kick">{t.projects.doula.kick}</div>
                    <div className="ps-shot-h" dangerouslySetInnerHTML={{ __html: t.projects.doula.heading }} />
                    <div className="ps-shot-cta">{t.projects.doula.cta}</div>
                </div>
            </div>
        </div>
    );
}

function UnicasPreview({ t }) {
    return (
        <div className="ps-browser" data-testid="unicas-browser">
            <div className="ps-browser-bar">
                <i /><i /><i />
                <span className="ps-browser-url">unicas-nail-estudio.netlify.app</span>
            </div>
            <div className="ps-browser-shot ps-shot-unicas">
                <ShotBg
                    image="/assets/images/unicas-hero.webp"
                    position="center 45%"
                    shade="rgba(15,15,16,0.46), rgba(15,15,16,0.78)"
                />
                <div className="ps-shot-nav">
                    <div className="ps-shot-brand" style={{ fontFamily: "serif", letterSpacing: "0.06em" }}>
                        <b>Únicas</b>
                    </div>
                    <em>{t.projects.unicas.cta}</em>
                </div>
                <div className="ps-shot-hero">
                    <div className="ps-shot-kick">{t.projects.unicas.kick}</div>
                    <div className="ps-shot-h" dangerouslySetInnerHTML={{ __html: t.projects.unicas.heading }} />
                    <div className="ps-shot-cta">{t.projects.unicas.cta}</div>
                </div>
            </div>
        </div>
    );
}

function SoonPreview({ t }) {
    return (
        <div className="ps-soon" aria-hidden="true">
            <div className="ps-soon-grid" />
            <div className="ps-soon-center">
                <div className="ps-soon-badge-top ps-mono">
                    <span className="pulse" />
                    <span>{t.projects.soon.badge}</span>
                </div>
                <div className="ps-soon-big" dangerouslySetInnerHTML={{ __html: t.projects.soon.big }} />
                <div className="ps-soon-hint ps-mono">{t.projects.soon.hint}</div>
            </div>
        </div>
    );
}

const PREVIEWS = {
    caminos: CaminosPreview,
    monarch: MonarchPreview,
    jav: JavPreview,
    visual414: Visual414Preview,
    fasttire: FastTirePreview,
    doula: DoulaPreview,
    unicas: UnicasPreview,
    soon: SoonPreview,
};

/* Por encima de este ancho el acordeón es horizontal y se abre con el ratón.
   Por debajo se apila en vertical y se abre al tocar, porque no hay hover y
   las columnas contraídas quedarían por debajo del mínimo táctil. */
const DESKTOP_MQ = "(min-width: 901px)";

function Arrow({ dir }) {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
            style={{ transform: dir === "prev" ? "rotate(180deg)" : undefined }}>
            <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
    );
}

function Chevron() {
    return (
        <svg className="ps-spine-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M6 9l6 6 6-6" />
        </svg>
    );
}

export default function Projects() {
    const trackRef = useRef(null);
    const { t } = useLanguage();
    const [active, setActive] = useState(0);
    const [isDesktop, setIsDesktop] = useState(
        () => typeof window !== "undefined" && window.matchMedia(DESKTOP_MQ).matches
    );

    useEffect(() => {
        const mq = window.matchMedia(DESKTOP_MQ);
        const onChange = (e) => setIsDesktop(e.matches);
        mq.addEventListener("change", onChange);
        return () => mq.removeEventListener("change", onChange);
    }, []);

    const projects = t.projects.items.map((item, i) => ({ ...item, ...PROJECT_META[i] }));
    const total = projects.length;

    /* El ancho del panel abierto se mide del carril real. Calcularlo en CSS con
       100vw fallaba: esa unidad incluye la barra de scroll vertical y la capa
       abierta quedaba unos píxeles más ancha que el panel, recortándose. */
    const setOpenWidth = useCallback(() => {
        const track = trackRef.current;
        if (!track || !isDesktop) return;
        const cs = getComputedStyle(track);
        const panel = track.children[0];
        if (!panel) return;
        const pcs = getComputedStyle(panel);
        // Con flex-basis 0 los bordes quedan fuera del espacio repartible.
        const border = parseFloat(pcs.borderLeftWidth) + parseFloat(pcs.borderRightWidth);
        const gap = parseFloat(cs.columnGap) || 0;
        const free = track.clientWidth
            - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight)
            - gap * (total - 1)
            - border * total;
        // El abierto pesa --ps-open-flex y cada contraído 1 (ver App.css).
        const grow = parseFloat(cs.getPropertyValue("--ps-open-flex")) || 6;
        track.style.setProperty("--ps-open-w", `${(free * grow) / (grow + total - 1) + border}px`);
    }, [isDesktop, total]);

    useEffect(() => {
        setOpenWidth();
        window.addEventListener("resize", setOpenWidth);
        return () => window.removeEventListener("resize", setOpenWidth);
    }, [setOpenWidth]);

    const goTo = useCallback((i) => {
        setActive(Math.max(0, Math.min(total - 1, i)));
    }, [total]);

    /* En móvil el primer toque despliega el panel; sólo cuando ya está abierto
       el enlace lleva al proyecto. Evita abrir un sitio sin haberlo visto. */
    const onPanelClick = (e, i) => {
        if (!isDesktop && i !== active) {
            e.preventDefault();
            setActive(i);
        }
    };

    const onKeyDown = (e) => {
        if (e.key === "ArrowRight" || e.key === "ArrowDown") { e.preventDefault(); goTo(active + 1); }
        if (e.key === "ArrowLeft" || e.key === "ArrowUp") { e.preventDefault(); goTo(active - 1); }
    };

    const pad = (n) => String(n).padStart(2, "0");
    const nav = t.projects.carousel;

    return (
        <section id="projects" className="ps-section ps-relative-z" data-testid="projects-section">
            <div className="ps-container">
                <div className="ps-section-head ps-projects-head">
                    <h2 className="ps-display ps-section-title" data-split data-split-scroll data-testid="projects-title"
                        dangerouslySetInnerHTML={{ __html: t.projects.title }} />

                    <div className="ps-carousel-ctrl">
                        <button type="button" className="ps-carousel-btn" onClick={() => goTo(active - 1)}
                            disabled={active === 0} aria-label={nav.prev} data-testid="carousel-prev">
                            <Arrow dir="prev" />
                        </button>
                        <div className="ps-carousel-count ps-mono" aria-live="polite" data-testid="carousel-count">
                            <span>{pad(active + 1)}</span>
                            <i>/</i>
                            <span className="is-total">{pad(total)}</span>
                        </div>
                        <button type="button" className="ps-carousel-btn" onClick={() => goTo(active + 1)}
                            disabled={active === total - 1} aria-label={nav.next} data-testid="carousel-next">
                            <Arrow dir="next" />
                        </button>
                    </div>
                </div>
            </div>

            <div className="ps-carousel" data-testid="projects-carousel">
                <div
                    ref={trackRef}
                    className="ps-carousel-track"
                    data-testid="projects-track"
                    tabIndex={0}
                    role="group"
                    aria-roledescription="acordeón"
                    aria-label={nav.label}
                    onKeyDown={onKeyDown}
                >
                    {projects.map((p, i) => {
                        const Preview = PREVIEWS[p.type];
                        const open = i === active;
                        return (
                            <a
                                key={p.id}
                                href={p.href}
                                target={p.href.startsWith("http") ? "_blank" : undefined}
                                rel="noopener noreferrer"
                                className={`ps-project ps-project-rich${open ? " is-open" : ""}`}
                                data-project
                                data-testid={`project-${p.id}`}
                                aria-expanded={open}
                                onMouseEnter={() => isDesktop && setActive(i)}
                                onFocus={() => isDesktop && setActive(i)}
                                onClick={(e) => onPanelClick(e, i)}
                            >
                                <span className={`ps-project-live${p.live ? "" : " is-soon"}`}
                                    data-testid={p.live ? `project-${p.id}-live` : undefined}>
                                    <span className="pulse" />
                                    <span>{p.live ? t.projects.liveLabel : t.projects.soonLabel}</span>
                                </span>

                                {/* Cabecera del panel: en escritorio es la tira vertical
                                    contraída, en móvil la fila que se pulsa para abrir. */}
                                <div className="ps-project-spine">
                                    {p.img && (
                                        <div className="ps-spine-bg" aria-hidden="true" style={{ backgroundImage: `url(${p.img})` }} />
                                    )}
                                    <span className="ps-spine-idx ps-mono">{p.id}</span>
                                    <span className="ps-spine-title">{p.title}</span>
                                    <Chevron />
                                </div>

                                <div className="ps-project-full">
                                    <div className="ps-project-preview">
                                        <Preview t={t} />
                                    </div>

                                    <div className="ps-project-meta">
                                        <div>
                                            <div className="ps-project-idx">[ {p.id} / {pad(total)} ]</div>
                                            <h3 className="ps-project-title">{p.title}</h3>
                                            <div className="ps-project-tag ps-mono">{p.tag}</div>
                                        </div>
                                        <span className="ps-project-open" aria-hidden="true">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
                                                <path d="M7 17L17 7M17 7H8M17 7v9" />
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                            </a>
                        );
                    })}
                </div>
            </div>

            <div className="ps-container">
                <div className="ps-carousel-progress" data-testid="carousel-progress">
                    {projects.map((p, i) => (
                        <button
                            key={p.id}
                            type="button"
                            className={`ps-carousel-dot${i === active ? " is-active" : ""}`}
                            onClick={() => goTo(i)}
                            aria-label={`${nav.goTo} ${p.title}`}
                            aria-current={i === active ? "true" : undefined}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}
